var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconErrorCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 38.81 38.8075 50 25 50C11.1925 50 0 38.81 0 25C0 11.195 11.1925 0 25 0C38.8075 0 50 11.195 50 25Z",
    fill: "#F65164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.296 29.8917L28.404 25.0024L33.2933 20.1131C34.2337 19.1754 34.2337 17.6492 33.2933 16.7115C32.3528 15.7656 30.8321 15.7683 29.8917 16.7088L24.9997 21.5981L20.1076 16.7033C19.1672 15.7628 17.6437 15.7683 16.7033 16.7033C15.7656 17.6437 15.7656 19.1699 16.7033 20.1076L21.5981 25.0024L16.7143 29.8834C15.7738 30.8239 15.7738 32.3501 16.7143 33.285C17.1845 33.758 17.7977 33.9917 18.4137 33.9917C19.0324 33.9917 19.6456 33.758 20.1159 33.2878L24.9997 28.404L29.8944 33.296C30.3647 33.7663 30.9779 34 31.5939 34C32.2098 34 32.8258 33.7635 33.296 33.296C34.2365 32.3556 34.2365 30.8321 33.296 29.8917Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorCircle);
export default __webpack_public_path__ + "static/media/icon-error-circle.804f22d7.svg";
export { ForwardRef as ReactComponent };